import { ApiResponse } from "@/types/apis";
import request from "@/utils/request";

type STSCredentials = {
  accessKeyId: string;
  accessKeySecret: string;
  expiration: string;
  securityToken: string;
};

// 获取STS凭证
export const getSTSCredentials = () =>
  request.get<ApiResponse<STSCredentials>>("/oss/getAliCloudSts");
